import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
import wash from '../assets/images/car_wash2.jpg'

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="https://images.unsplash.com/photo-1621905252507-b35492cc74b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Electrical installation and maintenance" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Why Choose Orient Engineers?</h2>
            <p>Located at 9 Mount Zion Road, Umule Aba, Orient Engineers has been providing reliable electrical installation and maintenance services. We are consultants and experts on all kinds of electrical installations, specializing in domestic and industrial solutions.</p>
            
            <div className="features">
              {[
                { icon: 'fas fa-certificate', title: 'Certified Expertise', desc: 'Professional electrical consultants with extensive experience in domestic and industrial installations.' },
                { icon: 'fas fa-tools', title: 'Complete Solutions', desc: 'From installation to maintenance, we provide comprehensive electrical services including inverters and CCTV systems.' },
                { icon: 'fas fa-shield-alt', title: 'Reliable Service', desc: 'Dependable electrical solutions designed for safety, efficiency, and long-term performance.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '15+', label: 'Years Experience' },
              { number: '500+', label: 'Projects Completed' },
              { number: '100%', label: 'Customer Satisfaction' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;